import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb"; // Import UK locale
import { DateTimeRangePicker } from "@mui/x-date-pickers-pro";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { TextField, Box, FormControlLabel, Checkbox } from "@mui/material";
import { unavailableDates, shouldDisableDate } from "../../services/helper";
import RepeatDate from "./RepeatDate";
function CalendarRangePicker({ formData, handleChange, formatType }) {
  const [isEntireDay, setIsEntireDay] = useState(true);
  const [isRepeatOvertime, setIsRepeatOvertime] = useState(false);
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (formData.repeatDate) {
      setIsRepeatOvertime(true);
    }
  }, [formData.repeatDate]);
  const handleDateRangeChange = (newValue) => {
    const [start, end] = newValue;

    if (start && end) {
      let currentDate = dayjs(start);
      const endDate = dayjs(end);
      while (
        currentDate.isBefore(endDate) ||
        currentDate.isSame(endDate, "day")
      ) {
        const dateToCheck = currentDate;
        if (
          unavailableDates.some((unavailableDate) =>
            dateToCheck.isSame(unavailableDate, "day"),
          )
        ) {
          alert(
            "The selected range includes an unavailable date. Please choose a different range.",
          );
          const syntheticEvent = {
            target: {
              name: "dateRange",
              value: [start, null], // Keep start date and clear end date
            },
          };
          handleChange(syntheticEvent);
          setKey((prevKey) => prevKey + 1);
          return;
        }
        currentDate = currentDate.add(1, "day");
      }
    }
    const syntheticEvent = {
      target: {
        name: "dateRange",
        value: newValue,
      },
    };
    handleChange(syntheticEvent);
  };

  const handleCheckboxChange = (event) => {
    setIsEntireDay(event.target.checked);
  };
  const handleRepeatOvertimeChange = (event) => {
    setIsRepeatOvertime(event.target.checked);
  };

  // const handleRepeatDatesChange = (newValue) => {
  //   if (newValue) {
  //     if (
  //       unavailableDates.some((unavailableDate) =>
  //         dayjs(newValue).isSame(unavailableDate, "day"),
  //       )
  //     ) {
  //       alert("This day is not available.");
  //       return;
  //     }
  //     setSelectedRepeatDates((prev) => [...prev, newValue]);
  //   }
  //   const syntheticEvent = {
  //     target: {
  //       name: "dateRange",
  //       value: [...selectedRepeatDates, newValue],
  //     },
  //   };
  //   handleChange(syntheticEvent);
  // };

  const dateFormat =
    formatType !== "holiday"
      ? "hh:mm A DD/MM/YY"
      : isEntireDay
        ? "DD/MM/YY hh:mm A"
        : "DD/MM/YY";

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
        sx={{ width: "100%" }}
      >
        {formatType === "holiday" ? (
          <>
            {isEntireDay ? (
              <DateTimeRangePicker
                key={key}
                calendars={2}
                name="dateRange"
                value={formData.dateRange}
                shouldDisableDate={shouldDisableDate}
                onChange={handleDateRangeChange}
                format={dateFormat}
                ampm={!isEntireDay}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField
                      {...startProps}
                      helperText="Start date (DD/MM/YYYY)"
                    />
                    <Box sx={{ mx: 2 }}> to </Box>
                    <TextField
                      {...endProps}
                      helperText="End date (DD/MM/YYYY)"
                    />
                  </>
                )}
              />
            ) : (
              <DateRangePicker
                key={key}
                calendars={2}
                name="dateRange"
                value={formData.dateRange}
                onChange={handleDateRangeChange}
                format="DD/MM/YYYY"
                shouldDisableDate={shouldDisableDate}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField
                      {...startProps}
                      helperText="Start date (DD/MM/YYYY)"
                    />
                    <Box sx={{ mx: 2 }}> to </Box>
                    <TextField
                      {...endProps}
                      helperText="End date (DD/MM/YYYY)"
                    />
                  </>
                )}
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={isEntireDay}
                  onChange={handleCheckboxChange}
                />
              }
              label="Entire Day"
            />
          </>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            width="100%"
            gap={2}
          >
            <DateTimeRangePicker
              key={key}
              calendars={2}
              name="dateRange"
              value={formData.dateRange}
              onChange={handleDateRangeChange}
              format={dateFormat}
              shouldDisableDate={shouldDisableDate}
              ampm={!isEntireDay}
              renderInput={(startProps, endProps) => (
                <>
                  <TextField
                    {...startProps}
                    helperText="Start date (DD/MM/YYYY)"
                  />
                  <Box sx={{ mx: 2 }}> to </Box>
                  <TextField {...endProps} helperText="End date (DD/MM/YYYY)" />
                </>
              )}
            />
            {isRepeatOvertime && (
              <RepeatDate formData={formData} handleChange={handleChange} />
            )}
            {formData.dateRange[0] && formData.dateRange[1] && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isRepeatOvertime}
                    onChange={handleRepeatOvertimeChange}
                  />
                }
                label="Repeat Overtime"
              />
            )}
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
}

export default CalendarRangePicker;
